import {useRoutes} from 'react-router-dom';
import {routes as mainRoutes} from '@/routes';
import {SecurityProvider} from '@/services/auth';
import {ThemeProvider} from '@/services/theme';
import './styles/main.scss';

export const App = () => {
  const routes = useRoutes(mainRoutes);

  return (
    <SecurityProvider>
      <ThemeProvider>{routes}</ThemeProvider>
    </SecurityProvider>
  );
};
